import React from "react";
import Box from "@mui/material/Box";
import Columns from "../../../atoms/Columns";
import Column from "../../../atoms/Column";
import { Props } from "../../../pages/Crew/Arrival/Create/types";
import { TableCell, Typography } from "@mui/material";
import CommonText from "../../../atoms/CommonText";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CustomOwnerTableCell from "../../../atoms/CustomOwnerTableCell";
import {
  TableDataRow,
  Table2DataRow,
  Table3DataRow,
  Table6DataRow,
  SpareDataRow,
} from "../../../molecules/Owner/Detail/Detail";
import { formatToUtcYYYYMMDDHHMM } from "../../../../utils/formats";
import { TableAnyDataRow } from "../../../molecules/Owner/Detail/Detail";
import { filterAdditionalROBForArrivalByFuelType } from "../../Crew/Arrival/ROB/RobAdditional.module";
import { FuelType } from "../../../../gen/graphql/types";

type FormBlockProps = Props & {
  pageTitle: string;
  isPreview: boolean;
};

const Detail = (props: FormBlockProps): React.ReactElement => {
  return (
    <Box component="form" noValidate autoComplete="off">
      <Box sx={{ pt: 0.5, mx: 2 }}>
        <Columns
          sx={{
            display: "flex",
            alignItems: "top",
            justifycontent: "right",
            pb: 1,
          }}
        >
          <Column>
            <Typography
              component="h3"
              variant="subtitle1"
              align="center"
              sx={{
                lineHeight: 1,
                fontWeight: "bold",
                color: "#333333",
                fontSize: "1.5rem",
                verticalAlign: "super",
              }}
            >
              {props.pageTitle}
            </Typography>
          </Column>
        </Columns>
      </Box>
      <CommonText
        sx={{ color: "#FFFFFF", pl: 3, margin: "left", textAlign: "left" }}
      >
        {props.isPreview || `Confirm input data & click “Save” button.`}
      </CommonText>

      <Box sx={{ px: 2 }}>
        <Table
          color="inherit"
          sx={{ minWidth: 600, mx: 0, color: "#FFFFFF" }}
          aria-label="spanning table"
        >
          <TableHead>
            <TableRow sx={{ borderBottom: "#FFFFFF", height: "20px" }}>
              <CustomOwnerTableCell
                align="center"
                colSpan={3}
              ></CustomOwnerTableCell>
              <CustomOwnerTableCell />
              <CustomOwnerTableCell
                sx={{ color: "#AAAAAA", fontSize: "12px" }}
              ></CustomOwnerTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableDataRow title={"Vessel Name"} data={props.form.A_Vessel_Name}/>
            <TableDataRow title={"Voyage number"} data={props.form.A_Voy} />
            <TableDataRow title={"L or B"} data={props.form.A_LorB} />
            <TableDataRow
              title={"Port name"}
              data={props.form.A_Arrival_Port}
            />
            <TableDataRow title={"UNLOC"} data={props.form.A_UNLOC} />
            <TableDataRow title={"EU/UK"} data={props.form.A_EU_UK_port} />
            <TableDataRow title={"L or U"} data={props.form.A_Port_L_U} />
            <TableDataRow
              title={"Arrival Date & Time (Local)"}
              data={formatToUtcYYYYMMDDHHMM(props.form.A_Arrival_Date_Time)}
            />
            <TableDataRow
              title={"S/B or Stop Date & Time (Local)"}
              data={formatToUtcYYYYMMDDHHMM(props.form.A_SB_or_Stop)}
            />
            <TableDataRow
              title={"Time Zone (UTC±)"}
              data={
                String(props.form.A_TimeZone_PorN) +
                props.form.A_TimeZone_HH +
                ":" +
                props.form.A_TimeZone_MM
              }
            />
            <TableDataRow
              title={"Berthed (Local)"}
              data={formatToUtcYYYYMMDDHHMM(props.form.A_Berthed)}
            />
            <TableDataRow
              title={`ETB`}
              data={formatToUtcYYYYMMDDHHMM(props.form.A_ETB)}
            />

            <TableDataRow
              title={`ETC`}
              data={formatToUtcYYYYMMDDHHMM(props.form.A_ETC)}
            />
            <TableDataRow
              title={`ETD`}
              data={formatToUtcYYYYMMDDHHMM(props.form.A_ETD)}
            />
            <Table6DataRow
              topTitle={"ROB"}
              title1={"FO (mt)"}
              data1={props.form.A_ROB_at_Arrival_FO}
              title2={"MGO (mt)"}
              data2={props.form.A_ROB_at_Arrival_MGO}
              title3={"MECO (L)"}
              data3={props.form.A_ROB_at_Arrival_MECO}
              title4={"MESO (L)"}
              data4={props.form.A_ROB_at_Arrival_MESO}
              title5={"GESO (L)"}
              data5={props.form.A_ROB_at_Arrival_GESO}
              title6={"FW (mt)"}
              data6={props.form.A_ROB_at_Arrival_FW}
              unitName1={"mt"}
              unitName2={"L"}
            />
            <TableDataRow
              title={`Hours since last noon report (hour)`}
              data={props.form.A_Hrs_since_Last_Noon}
            />
            <TableDataRow
              title={`Distance travelled over ground (nautical mile)`}
              data={props.form.A_Distance_by_OG}
            />
            <Table3DataRow
              topTitle={"FO Consumption per day"}
              title1={"M/E (mt)"}
              data1={props.form.A_FO_Consumption_per_day_ME}
              unitName={"mt"}
              title2={"G/E (mt)"}
              data2={props.form.A_FO_Consumption_per_day_GE}
              title3={`Boiler & Incinerator (mt)`}
              data3={props.form.A_FO_Consumption_per_day_B_and_Inc}
            />
            <Table3DataRow
              topTitle={"MGO Consumption per day"}
              title1={"M/E (mt)"}
              data1={props.form.A_MGO_Consumption_per_day_ME}
              unitName={"mt"}
              title2={"G/E (mt)"}
              data2={props.form.A_MGO_Consumption_per_day_GE}
              title3={`Boiler & Incinerator (mt)`}
              data3={props.form.A_MGO_Consumption_per_day_B_and_Inc}
            />
            <Table6DataRow
              topTitle={"ROB"}
              title1={"FO (mt)"}
              data1={props.form.A_ROB_FO}
              title2={"MGO (mt)"}
              data2={props.form.A_ROB_MGO}
              title3={"MECO (L)"}
              data3={props.form.A_ROB_MECO}
              title4={"MESO (L)"}
              data4={props.form.A_ROB_MESO}
              title5={"GESO (L)"}
              data5={props.form.A_ROB_GESO}
              title6={"FW (mt)"}
              data6={props.form.A_ROB_FW}
              unitName1={"mt"}
              unitName2={"L"}
            />
            <TableAnyDataRow
              topTitle={"Additional ROB"}
              title={
                filterAdditionalROBForArrivalByFuelType(Object.values(FuelType), [
                  ...(props.form.A_Additional_ROB || []),
                ])?.map((v) => v.A_Fuel_Type) || []
              }
              data={
                filterAdditionalROBForArrivalByFuelType(Object.values(FuelType), [
                  ...(props.form.A_Additional_ROB || []),
                ])?.map((v) => v.A_Fuel_volume) || []
              }
              unitName={Array(
                filterAdditionalROBForArrivalByFuelType(Object.values(FuelType), [
                  ...(props.form.A_Additional_ROB || []),
                ])?.length
              ).fill("mt")}
            />
            <Table2DataRow
              topTitle={"Draft"}
              title1={"Fore (m)"}
              data1={props.form.A_Draft_Fore}
              unitName={"m"}
              title2={"Aft (m)"}
              data2={props.form.A_Draft_Aft}
            />
            <TableDataRow
              title={`FO CO2 emission`}
              data={props.form.A_FO_CO2_emission}
              unitName={"mt"}
            />
            <TableDataRow
              title={`MGO CO2 emission`}
              data={props.form.A_MGO_CO2_emission}
              unitName={"mt"}
            />
            <TableDataRow title={`Remark`} data={props.form.A_Remark} />

            <TableRow>
              <TableCell
                rowSpan={21}
                sx={{
                  verticalAlign: "top",
                  color: "#888888",
                  borderBottom: "1px solid #C9D0DC",
                }}
              >
                Spare
              </TableCell>
            </TableRow>
            <SpareDataRow
              title={`Spare 1`}
              data={props.form.A_Spare_1}
              unitName={props.form.A_Spare_1_unit_name}
            />
            <SpareDataRow
              title={`Spare 2`}
              data={props.form.A_Spare_2}
              unitName={props.form.A_Spare_2_unit_name}
            />
            <SpareDataRow
              title={`Spare 3`}
              data={props.form.A_Spare_3}
              unitName={props.form.A_Spare_3_unit_name}
            />
            <SpareDataRow
              title={`Spare 4`}
              data={props.form.A_Spare_4}
              unitName={props.form.A_Spare_4_unit_name}
            />
            <SpareDataRow
              title={`Spare 5`}
              data={props.form.A_Spare_5}
              unitName={props.form.A_Spare_5_unit_name}
            />
            <SpareDataRow
              title={`Spare 6`}
              data={props.form.A_Spare_6}
              unitName={props.form.A_Spare_6_unit_name}
            />
            <SpareDataRow
              title={`Spare 7`}
              data={props.form.A_Spare_7}
              unitName={props.form.A_Spare_7_unit_name}
            />
            <SpareDataRow
              title={`Spare 8`}
              data={props.form.A_Spare_8}
              unitName={props.form.A_Spare_8_unit_name}
            />
            <SpareDataRow
              title={`Spare 9`}
              data={props.form.A_Spare_9}
              unitName={props.form.A_Spare_9_unit_name}
            />
            <SpareDataRow
              title={`Spare 10`}
              data={props.form.A_Spare_10}
              unitName={props.form.A_Spare_10_unit_name}
            />
            <SpareDataRow
              title={`Spare 11`}
              data={props.form.A_Spare_11}
              unitName={props.form.A_Spare_11_unit_name}
            />
            <SpareDataRow
              title={`Spare 12`}
              data={props.form.A_Spare_12}
              unitName={props.form.A_Spare_12_unit_name}
            />
            <SpareDataRow
              title={`Spare 13`}
              data={props.form.A_Spare_13}
              unitName={props.form.A_Spare_13_unit_name}
            />
            <SpareDataRow
              title={`Spare 14`}
              data={props.form.A_Spare_14}
              unitName={props.form.A_Spare_14_unit_name}
            />
            <SpareDataRow
              title={`Spare 15`}
              data={props.form.A_Spare_15}
              unitName={props.form.A_Spare_15_unit_name}
            />
            <SpareDataRow
              title={`Spare 16`}
              data={props.form.A_Spare_16}
              unitName={props.form.A_Spare_16_unit_name}
            />
            <SpareDataRow
              title={`Spare 17`}
              data={props.form.A_Spare_17}
              unitName={props.form.A_Spare_17_unit_name}
            />
            <SpareDataRow
              title={`Spare 18`}
              data={props.form.A_Spare_18}
              unitName={props.form.A_Spare_18_unit_name}
            />
            <SpareDataRow
              title={`Spare 19`}
              data={props.form.A_Spare_19}
              unitName={props.form.A_Spare_19_unit_name}
            />
            <SpareDataRow
              title={`Spare 20`}
              data={props.form.A_Spare_20}
              unitName={props.form.A_Spare_20_unit_name}
            />
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default Detail;
